import { useRecoilValue } from 'recoil';

import useHasScrollbar from 'lib/hooks/useHasScrollbar';
import { cn, hasModule, iaRa, pm } from 'lib/helpers/utility';

import { modulesState, permissions as permissionsState } from 'components/state';

import Item from './Item';

const List = ({ items = [], activeItem, onChange }) => {
  const [ref, hasScrollbar] = useHasScrollbar();

  const permissions = useRecoilValue(permissionsState);
  const practiceModules = useRecoilValue(modulesState);

  const checkPerm = (p) => !p || pm(permissions, p);
  const checkModule = (m) => !m || hasModule(practiceModules, m);

  return (
    <div className={cn('w-full overflow-hidden p-3', hasScrollbar && 'pr-0')}>
      <div
        ref={ref}
        className="flex h-full flex-col overflow-y-auto overflow-x-hidden xs:h-auto xs:flex-row xs:flex-wrap xs:gap-x-3 xs:overflow-visible">
        {items.map((group) => {
          if (!checkPerm(group?.permission) || !checkModule(group?.module)) return;

          const visibleItems = iaRa(group.items).filter(
            (child) =>
              child?.key &&
              !child.hidden &&
              checkPerm(child?.permission) &&
              checkModule(child?.module)
          );

          if (visibleItems.length === 0) return null;

          return (
            <div key={group.title} className="my-3 flex flex-col gap-[4px] xs:my-1 xs:w-full">
              <span className="flex pb-1 text-xs uppercase leading-[14px] text-neutral-600">
                {group.title}
              </span>

              <div className="flex flex-col gap-[4px] xs:flex-row xs:flex-wrap">
                {visibleItems.map((child) => {
                  const isActive = child.key === activeItem?.key;

                  return (
                    <Item
                      key={child.key}
                      item={child}
                      isActive={isActive}
                      onClick={() => onChange?.(child)}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default List;
